"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Browse: "Sfoglia",
  Change: "Modifica",
  "Drop your image here": "Rilascia l'immagine qui",
  "Drop your logo here": "Rilascia il logo qui",
  Remove: "Elimina",
  "Revert to default": "Ripristina alle impostazioni predefinite",
  "Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.": ['Spiacenti, "', ["fileName"], '" è più grande di ', ["maxFileSize"], " e non può essere caricato. Carica un file di ", ["maxFileSize"], " o di dimensioni inferiori."],
  "Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.": ['Spiacenti, "', ["fileName"], '" è più piccolo di ', ["minFileSize"], " e non può essere caricato. Carica un file di ", ["minFileSize"], " o di dimensioni superiori."],
  "Sorry, this image format isn't supported. Please provide a {fileTypes}.": ["Spiacenti, questo formato immagine non è supportato. Fornisci un file in formato ", ["fileTypes"], "."],
  "Unsupported file type": "Tipo di file non supportato"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map